import { Box, BoxProps } from '@chakra-ui/react'
import React from 'react'

interface InputCounterProps extends BoxProps {
  characterCount: number
  maxCharacterCount: number
}

const InputCounter = ({
  characterCount,
  maxCharacterCount,
  ...restProps
}: InputCounterProps) => (
  <Box
    as="span"
    color={characterCount >= maxCharacterCount ? 'apex.orangeRed' : undefined}
    padding="0 0.25rem"
    wordBreak="initial"
    {...restProps}
  >
    {characterCount}/{maxCharacterCount}
  </Box>
)

export default InputCounter
